import Container from "../element/container";
import Icon from "../element/icon";

export default function AccountModalHeader({ title, subtitle, icon }) {
  return (
    <header className="account-modal-header">
      <span className="account-modal-header-icon" aria-hidden="true"><Icon tag="span" icon={icon} /></span>
      <Container tag="div" className="account-modal-header-copy">
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </Container>
    </header>
  );
}
